import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=56adeb5c"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=56adeb5c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBtn: require('/builds/project/wyffest/frontend/components/app/AppBtn.vue').default,AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default,AppContactFormDialog: require('/builds/project/wyffest/frontend/components/app/contact-form/AppContactFormDialog.vue').default})
